module.exports = __webpack_public_path__ + "img/leipzig.07edb8dd.png";